import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { getItem } from "@purple-dot/browser-sdk/src/libraries/local-storage";
import { SegmentWrapper } from "../components/common/segment";
var isInternalUser = function() {
    var internalUser = getItem("internal-user");
    if (!internalUser) {
        return false;
    }
    return internalUser.isInternalUser === true;
};
var isKnownBot = function() {
    var BOTS = /(pingdom)|(google)/i;
    return global.navigator.userAgent.match(BOTS);
};
var FilterWrapper = {
    identify: function(userId, traits, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            SegmentWrapper.identify(userId, traits, options, callback);
        } else {
            // eslint-disable-next-line no-console
            console.log("INTERNAL USER - Identify: ", userId);
        }
    },
    track: function(event, properties, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            SegmentWrapper.track(event, properties, options, callback);
        } else {
            // eslint-disable-next-line no-console
            console.log("INTERNAL USER - Track: ", event, properties, options, callback);
        }
    },
    page: function(category, name, properties, options, callback) {
        if (!(isInternalUser() || isKnownBot())) {
            SegmentWrapper.page(category, name, properties, options, callback);
        } else {
            // eslint-disable-next-line no-console
            console.log("INTERNAL USER - Page: ", category, name, properties, options, callback);
        }
    }
};
var Analytics = _object_spread_props(_object_spread({}, FilterWrapper), {
    trackTagScanned: function(param) {
        var itemId = param.itemId, scannedCode = param.scannedCode, shopCode = param.shopCode;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackTagScanned()");
        }
        if (!scannedCode) {
            throw new Error("No scannedCode provided to Analytics.trackTagScanned()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackTagScanned()");
        }
        FilterWrapper.track("Tag Scanned", {
            itemId: itemId,
            scannedCode: scannedCode,
            shopCode: shopCode
        });
    },
    trackCodeEntered: function(param) {
        var enteredCode = param.enteredCode, codeType = param.codeType;
        if (!enteredCode) {
            throw new Error("No enteredCode provided to Analytics.trackCodeEntered()");
        }
        if (!codeType) {
            throw new Error("No codeType provided to Analytics.trackCodeEntered()");
        }
        if (codeType === "tag") {
            FilterWrapper.track("Tag Code Entered", {
                enteredCode: enteredCode
            });
        } else if (codeType === "item") {
            FilterWrapper.track("Shareable Code Entered", {
                enteredCode: enteredCode
            });
        } else if (codeType === "external") {
            FilterWrapper.track("External Shop Code Entered", {
                enteredCode: enteredCode
            });
        }
    },
    trackInstagramLinkFollowed: function(param) {
        var itemId = param.itemId, shopCode = param.shopCode;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackInstagramLinkFollowed()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackInstagramLinkFollowed()");
        }
        FilterWrapper.track("Instagram Link Followed", {
            itemId: itemId,
            shopCode: shopCode
        });
    },
    trackImageGalleryInteraction: function(param) {
        var itemId = param.itemId;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackImageViewed()");
        }
        FilterWrapper.track("Interacted with Image Gallery", {
            itemId: itemId
        });
    },
    trackProductViewed: function(param) {
        var itemId = param.itemId, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackProductViewed()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackProductViewed()");
        }
        FilterWrapper.track("Product Viewed", {
            itemId: itemId,
            slug: slug,
            product_id: slug
        });
    },
    trackCheckoutStarted: function(param) {
        var itemId = param.itemId, shopCode = param.shopCode, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackCheckoutStarted()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackCheckoutStarted()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackCheckoutStarted()");
        }
        FilterWrapper.track("Checkout Started", {
            itemId: itemId,
            shopCode: shopCode,
            slug: slug,
            product_id: slug
        });
    },
    trackOrderSubmitted: function(param) {
        var itemId = param.itemId, shopCode = param.shopCode, slug = param.slug;
        if (!itemId) {
            throw new Error("No itemId provided to Analytics.trackOrderSubmitted()");
        }
        if (!shopCode) {
            throw new Error("No shopCode provided to Analytics.trackOrderSubmitted()");
        }
        if (!slug) {
            throw new Error("No slug provided to Analytics.trackOrderSubmitted()");
        }
        FilterWrapper.track("Order Submitted", {
            itemId: itemId,
            shopCode: shopCode,
            slug: slug
        });
    },
    trackOrderCreated: function(param) {
        var orderReference = param.orderReference;
        if (!orderReference) {
            throw new Error("No orderReference provided to Analytics.trackOrderCreated()");
        }
        FilterWrapper.track("Order Created", {
            orderReference: orderReference
        });
    },
    trackOrderFailed: function() {
        FilterWrapper.track("Order Failed");
    },
    trackShippingMethodSelected: function(param) {
        var shippingOption = param.shippingOption;
        if (!shippingOption) {
            throw new Error("No shippingOption provided to Analytics.trackShippingMethodSelected()");
        }
        FilterWrapper.track("Shipping Method Selected", {
            shippingOption: shippingOption
        });
    },
    trackPaymentMethodSelected: function(param) {
        var paymentMethod = param.paymentMethod;
        if (!paymentMethod) {
            throw new Error("No paymentMethod provided to Analytics.trackPaymentMethodSelected()");
        }
        FilterWrapper.track("Payment Method Selected", {
            paymentMethod: paymentMethod
        });
    },
    trackLearnMoreClicked: function() {
        FilterWrapper.track("Learn More Clicked");
    },
    trackLearnMoreModalDismissed: function() {
        FilterWrapper.track("Learn More Modal Dismissed");
    },
    trackSizeChanged: function(param) {
        var itemId = param.itemId, selectedItemId = param.selectedItemId, slug = param.slug;
        FilterWrapper.track("Size Changed", {
            itemId: itemId,
            selectedItemId: selectedItemId,
            slug: slug
        });
    },
    trackMerchantItemUrlVisit: function(param) {
        var source = param.source, itemMerchantUrl = param.itemMerchantUrl;
        FilterWrapper.track("Item Merchant Link Visited", {
            source: source,
            itemMerchantUrl: itemMerchantUrl
        });
    },
    trackTrendingItemSelected: function(param) {
        var itemId = param.itemId, slug = param.slug;
        FilterWrapper.track("Trending Item Selected", {
            itemId: itemId,
            slug: slug
        });
    },
    trackTrendingScrolled: function() {
        FilterWrapper.track("Trending Scrolled");
    },
    trackRetailerModalOpened: function() {
        FilterWrapper.track("Retailer Modal Opened");
    },
    trackShareModalOpened: function(param) {
        var itemId = param.itemId, slug = param.slug;
        FilterWrapper.track("Share Modal Opened", {
            itemId: itemId,
            slug: slug
        });
    },
    trackLastSeenProductClicked: function() {
        FilterWrapper.track("Last Seen Product Clicked");
    },
    trackInputChanged: function(param) {
        var name = param.name;
        if (!name) {
            throw new Error("No name provided to Analytics.trackInputChanged");
        }
        FilterWrapper.track("".concat(name, " Changed"));
    },
    trackSectionExpanded: function(param) {
        var title = param.title;
        if (!title) {
            throw new Error("No title provided to Analytics.trackSectionExpanded");
        }
        FilterWrapper.track("".concat(title, " Expanded"));
    },
    trackShareLinkFollowed: function(param) {
        var itemId = param.itemId;
        if (!itemId) {
            throw new Error("No title provided to Analytics.trackShareLinkFollowed");
        }
        FilterWrapper.track("Unique Product Share Link Followed", {
            itemId: itemId
        });
    },
    trackNewsletterSignup: function() {
        FilterWrapper.track("Newsletter Sign Up");
    },
    trackSuggestClicked: function() {
        FilterWrapper.track("Suggest an Item Clicked");
    },
    trackSuggestionSubmitted: function() {
        FilterWrapper.track("Suggestion Submitted");
    },
    trackExplainerVideoPlayed: function() {
        FilterWrapper.track("Explainer Video Played");
    },
    trackExplainerVideoPaused: function(param) {
        var timeViewed = param.timeViewed;
        FilterWrapper.track("Explainer Video Paused", {
            timeViewed: timeViewed
        });
    },
    trackUserProgressed: function(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserProgressed");
        }
        FilterWrapper.track("User Progressed", {
            pageName: pageName
        });
    },
    trackUserEngagedWithLandingPage: function(pageName) {
        if (!pageName) {
            throw new Error("No page provided to Analytics.trackUserEngagedWithLandingPage");
        }
        FilterWrapper.track("Engaged With Landing Page", {
            pageName: pageName
        });
    },
    trackSizeGuideClicked: function() {
        FilterWrapper.track("Size Guide Clicked");
    },
    trackVisitDemoStoreClicked: function() {
        FilterWrapper.track("Visit Demo Store Clicked");
    },
    trackGetInTouchClicked: function() {
        FilterWrapper.track("Get In Touch Clicked");
    },
    trackMerchantContactFormSubmitted: function() {
        FilterWrapper.track("Merchant Contact Form Submitted");
    },
    trackStoreSignupReview: function() {
        FilterWrapper.track("Store Review Form Submitted");
    },
    trackSurveyCTAClick: function() {
        FilterWrapper.track("Survey CTA Clicked");
    }
});
export default Analytics;
